import { SelectionBanner } from "../elements/SelectionBanner";
import { SearchSelectionBarProps } from "./SearchSelectionBar.types";

/**
 * The line above the results: what is selected on the left and the "..." menu on the right. Always there, so the menu is where it is before a search too. The selection message
 * waits for the results, so it never counts records still being read.
 */
export function SearchSelectionBar({
  search,
  alwaysShow = false,
  selectable = true,
  children,
}: SearchSelectionBarProps) {
  const { submitted, loading, records, total, pageSize, selection, selectedCount } = search;
  const allOnPageSelected =
    records.length > 0 &&
    (selection.allPages || records.every((record) => selection.ids.includes(record.Id)));

  return (
    <div className="d-flex align-items-center gap-2 py-2">
      <div className="me-auto min-w-0 flex-grow-1 flex-md-grow-0">
        {submitted && !loading && total > 0 && selectable && (
          <SelectionBanner
            alwaysShow={alwaysShow}
            hasMorePages={total > pageSize}
            totalRecords={total}
            allOnPageSelected={allOnPageSelected}
            allPagesSelected={selection.allPages}
            clearSelection={search.clearSelection}
            selectAllPages={search.selectAllPages}
            selectedCount={selectedCount}
          />
        )}
      </div>
      {children}
    </div>
  );
}
